import { prop, sortBy } from 'ramda';
import type { GamePlayerProjections } from '@library/types/projection';

const getElementRank = (
  element: GamePlayerProjections & { playerId: string }
): number => {
  const { projections: elementProjections } = element;

  if (!elementProjections.length) {
    return 0;
  }

  const [elementProjection] = elementProjections;
  const { rank: elementRank } = elementProjection;

  return elementRank;
};

export const sortPlayerProjections = (
  playerProjections: Array<GamePlayerProjections & { playerId: string }>
): Array<GamePlayerProjections & { playerId: string }> => {
  return playerProjections.sort((a, b) => {
    const firstElementRank = getElementRank(a);
    const secondElementRank = getElementRank(b);

    return firstElementRank - secondElementRank;
  });
};

export const sortByStatType = sortBy(prop('statType'));
